import React, { useState, useEffect } from "react";
import { MessageSquare, Edit2, Check, X } from "lucide-react";

const Announcement = ({ data, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(data?.content || "");
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    if (!editing) setDraft(data?.content || "");
  }, [data, editing]);

  const hasContent = data?.content && data.content.trim().length > 0;

  const handleSave = () => {
    onSave(draft.trim());
    setEditing(false);
  };

  const handleCancel = () => {
    setDraft(data?.content || "");
    setEditing(false);
  };

  if (!hasContent && !editing) {
    return (
      <button
        onClick={() => setEditing(true)}
        className="flex items-center gap-1 text-xs text-gray-400 hover:text-purple-600 py-1 transition-colors"
      >
        <MessageSquare size={12} />
        Add a family note
      </button>
    );
  }

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-3">
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-1.5 text-xs font-medium text-amber-700">
          <MessageSquare size={12} />
          Family Note
        </div>
        <div className="flex items-center gap-2">
          {!editing && (
            <>
              <button
                onClick={() => setExpanded((v) => !v)}
                className="text-[10px] text-amber-500 hover:text-amber-700"
              >
                {expanded ? "Hide" : "Show"}
              </button>
              <button
                onClick={() => { setEditing(true); setExpanded(true); }}
                className="text-amber-500 hover:text-amber-700"
                title="Edit note"
              >
                <Edit2 size={12} />
              </button>
            </>
          )}
        </div>
      </div>

      {expanded && (
        editing ? (
          <div>
            <textarea
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              className="w-full text-sm border border-amber-300 rounded p-2 resize-none focus:outline-none focus:ring-1 focus:ring-amber-400 bg-white"
              rows={3}
              autoFocus
              placeholder="Write a note visible to all family members..."
            />
            <div className="flex gap-2 mt-1 justify-end">
              <button
                onClick={handleCancel}
                className="flex items-center gap-1 text-xs text-gray-500 hover:text-gray-700 px-2 py-1 rounded"
              >
                <X size={12} /> Cancel
              </button>
              <button
                onClick={handleSave}
                className="flex items-center gap-1 text-xs text-amber-700 hover:text-amber-900 font-medium px-2 py-1 rounded bg-amber-100 hover:bg-amber-200"
              >
                <Check size={12} /> Save
              </button>
            </div>
          </div>
        ) : (
          <div>
            <p className="text-sm text-gray-700 whitespace-pre-wrap leading-snug">
              {data.content}
            </p>
            {data.updated_at && (
              <p className="text-[10px] text-gray-400 mt-1">
                {data.updated_by_name ? `${data.updated_by_name} · ` : ""}
                {new Date(data.updated_at).toLocaleDateString()}
              </p>
            )}
          </div>
        )
      )}
    </div>
  );
};

export default Announcement;
